/** @format */

export const schoolEducationLanguageModelModule = 'sis-components.model.schoolEducationLanguage';

('use strict');
(function () {
    schoolEducationLanguageJSDataModel.$inject = ['DS', '$http'];
    angular
        .module(schoolEducationLanguageModelModule, ['js-data'])
        .factory('schoolEducationLanguageJSDataModel', schoolEducationLanguageJSDataModel);

    function schoolEducationLanguageJSDataModel(DS, $http) {
        var model = DS.defineResource({
            idAttribute: 'urn',
            name: 'schoolEducationLanguage',
            endpoint: '/kori/api/cached/codebooks/urn:code:school-education-language',
            watchChanges: false,
        });
        model.lazyGetAll = _.once(function () {
            return $http.get(model.endpoint).then(function (response) {
                model.inject(_.values(response.data));
                return model.getAll();
            });
        });
        return model;
    }
})();
